<template>
  <span class="def-sale">
    <slot />
  </span>
</template>

<script>
export default {
  name: 'DefSale',
};
</script>

<style lang="scss" scoped>
.def-sale {
  color: var(--color-red);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 125%;
}
</style>
